module.exports = __webpack_public_path__ + "static/media/ic_delete.083ef036.svg";